import React from 'react';
import classes from './InputToTemplate.css'
const InputToTemplate = (props)=>{
    return(
        <div className={classes.templateInput}>
        <input type="text" name={props.name} placeholder={props.label} onChange={props.inputHandler} value={props.value}/>
    </div>
    )
}
export default InputToTemplate;